export function compileRoutePatternToRegex(pattern: string): RegExp | null {
  // If the pattern already looks like a raw regex (contains groups or character classes), use as-is
  if (/[()|[\]\\]/.test(pattern)) {
    try {
      return new RegExp(pattern);
    } catch {
      return null;
    }
  }

  // Support UUID placeholders and wildcard segments
  const UUID_SEGMENT =
    '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

  // Escape then replace tokens
  const source = escapeRegExp(pattern)
    .replace(/\\\*/g, '[^/]+')
    .replace(/:(uuid)/gi, UUID_SEGMENT)
    .replace(/\\\{uuid\\\}/gi, UUID_SEGMENT);

  try {
    return new RegExp(`^${source}$`);
  } catch {
    return null;
  }
}

export function isConfigEligibleForRoute(
  routes: string[] | undefined,
  pathname: string
): boolean {
  if (!routes || routes.length === 0) return true;
  return routes.some((route) => {
    const compiled = compileRoutePatternToRegex(route);
    if (compiled) return compiled.test(pathname);
    return pathname.startsWith(route);
  });
}

function escapeRegExp(value: string) {
  return value.replace(/[\].*+?^${}()|\\]/g, '\\$&');
}
